import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VFlex,[(_vm.p_isPrintMode)?_c('img-photo',{attrs:{"p_width":100},on:{"imgPhotoLoad":function($event){return _vm.$emit('photoLoad')}}}):_c(VLayout,{class:[_vm.$style.photoWithLabel, _vm.photoPadding],attrs:{"column":"","align-center":""}},[(_vm.isNormalPhoto)?_c('img-photo',{attrs:{"p_width":150}}):_c('img-photo',{attrs:{"p_width":200}}),_c(VFlex,{staticClass:"body-2",attrs:{"flex-grow-0":""}},[_vm._v(_vm._s(_vm.$langs.title('photo_itsMe')))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }